import React from 'react';
import { Stack } from '@mui/material';
import PropTypes from 'prop-types';
import StaffInfoCard from '../../../components/cards/StaffInfoCard';
import { STACK_CENTER } from '../../../constants/mui-components';

const TeamGrid = ({ people }) => {
  const handlePersonClick = (person) => {
    if (person.linkedinUrl) {
      window.open(person.linkedinUrl, '_blank');
    }
  };

  return (
    <Stack
      sx={{
        display: 'grid',
        alignItems: 'center',
        justifyItems: 'center',
        gridTemplateColumns: {
          xs: 'repeat(3, 1fr)',
          sm: 'repeat(3, 1fr)',
          m: 'repeat(4, 1fr)',
          md: 'repeat(6, 1fr)',
        },
        gap: { xs: '1.2rem', sm: '2rem' },
        width: '100%',
        maxWidth: '75rem',
      }}
    >
      {people.map((person) => (
        <StaffInfoCard
          className={STACK_CENTER}
          key={person.user.id}
          person={person}
          onClick={() => handlePersonClick(person)}
        />
      ))}
    </Stack>
  );
};

TeamGrid.propTypes = {
  people: PropTypes.arrayOf(PropTypes.shape({
    user: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    position: PropTypes.string.isRequired,
    picture: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  })).isRequired,
};

export default TeamGrid;
